import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getFormLayoutTranslations } from 'utils/helios/language';
import type { GetTemplateFormLayoutRes } from 'types';

export const useFormLayoutTranslations = (formLayout: GetTemplateFormLayoutRes | undefined): Record<number, string> => {
  const { i18n } = useTranslation();

  return useMemo(
    () => getFormLayoutTranslations({ language: i18n.language, resolvedLanguage: i18n.resolvedLanguage }, formLayout),
    [formLayout, i18n.language, i18n.resolvedLanguage]
  );
};
